import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { SvgIcon } from 'core/icons';
import Raw from '../../common/Raw';
import {
  BYO_CLOSE,
  addCustomEvent,
  removeCustomEvent,
} from '../../utils/customMessage';
import { useNotifications } from '../../common/notifications/NotificationsContext';
import ThirdPartyModal from '../../main/thirdPartyModal/ThirdPartyModal';
import { connect } from 'react-redux';
import NotificationModal from './notificationModal/NotificationModal';
export class Notification extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();

    this.state = {
      isClosing: false,
      close: false,
      isFullScreen: props.message.length > 200,
    };
    this.isSubscribed = true;
  }

  onCloseButtonClick = (e) => {
    this.onClose(e, true);
  };

  onClose = (e, force = false) => {
    if (e.type === 'click' && this.ref.current.contains(e.target) && !force) {
      return;
    }

    this.setState({
      isClosing: true,
    });

    // We need to wait the CSS slidedown animation done before running the closing logic
    setTimeout(() => {
      if (this.isSubscribed) {
        this.setState({
          isClosing: false,
          close: true,
        });
      }
      this.props.onClose();
    }, 450);
  };

  closeOnEscape = (e) => {
    e.stopPropagation();
    if (e.key === 'Escape' && this.state.externalUrl) {
      this.onThirdPartyDisclosureClose();
    } else if (e.key === 'Escape') {
      this.onClose(e);
    }
  };

  stopPropagation = (event) => {
    event.stopPropagation();
  };

  checkIfExternalLink = (e) => {
    const url = e?.target?.href;

    if (e.target.parentElement.className !== 'modal') {
      e.preventDefault();
      e.stopPropagation();
    }

    if (url && url.slice(-1) !== '#' && this.props.country === 'CA') {
      this.setState({ externalUrl: url });
    } else if (url && (url.slice(-1) === '#' || this.props.country !== 'CA')) {
      window.open(url, '_blank');
    }
  };

  onThirdPartyDisclosureClose = () => {
    this.setState({ externalUrl: null });
  };

  componentDidMount() {
    const currentContentEl =
      Array.from(document.querySelectorAll('.ReactModal__Content')).pop() ||
      window;
    const currentScrollEl =
      Array.from(document.querySelectorAll('.modal-body')).pop() || window;
    addEventListener('keydown', this.closeOnEscape, true);
    setTimeout(() => {
      const isFullScreen = this.ref.current.clientHeight >= window.innerHeight;
      if (isFullScreen) {
        document.body.style.overflow = 'hidden';
      } else {
        currentScrollEl.addEventListener('scroll', this.onClose);
        currentContentEl.addEventListener('click', this.onClose);
        addCustomEvent(BYO_CLOSE, this.onClose);
      }

      window.addEventListener('click', this.checkIfExternalLink);
    });
  }

  componentWillUnmount() {
    const currentContentEl =
      Array.from(document.querySelectorAll('.ReactModal__Content')).pop() ||
      window;
    const currentScrollEl =
      Array.from(document.querySelectorAll('.modal-body')).pop() || window;
    removeEventListener('keydown', this.closeOnEscape, true);
    this.isSubscribed = false;
    currentScrollEl.removeEventListener('scroll', this.onClose);
    currentContentEl.removeEventListener('click', this.onClose);
    window.removeEventListener('click', this.checkIfExternalLink);
    removeCustomEvent(BYO_CLOSE, this.onClose);
    document.body.style.overflow = '';
  }

  render() {
    const { message, messageIcon } = this.props;
    const { close, isClosing, isFullScreen, externalUrl } = this.state;
    return (
      <>
        <div
          className={`notifications__container ${
            isClosing ? 'notifications__container--closing' : ''
          } 
        ${close ? 'notifications__container--close' : ''}
        ${isFullScreen ? 'notifications__container--full-screen' : ''}`}
          ref={this.ref}>
          <div className="notifications" tabIndex={0}>
            <div
              className="notifications__inner"
              data-role="scroll"
              role="alert"
              aria-live="assertive"
              aria-atomic="true">
              {messageIcon ? (
                <div className="notifications__content">
                  <SvgIcon
                    name={messageIcon}
                    className="notifications__check"
                  />
                  <Raw as="span" value={message} />
                </div>
              ) : (
                <div
                  className="notifications__content"
                  dangerouslySetInnerHTML={{ __html: message }}
                />
              )}
              <div>
                <SvgIcon
                  name="close"
                  className="notifications__close stat-button-close"
                  data-dtm="disclosure"
                  onClick={this.onCloseButtonClick}
                />
              </div>
            </div>
          </div>
        </div>
        <ThirdPartyModal
          onClose={this.onThirdPartyDisclosureClose}
          url={externalUrl}
        />
      </>
    );
  }
}

const Notifications = ({ country }) => {
  const {
    message,
    visible,
    dismiss,
    messageIcon,
    useModal,
  } = useNotifications();
  const container = useRef(document.createElement('div'));

  useEffect(() => {
    document.body.appendChild(container.current);
    return () => {
      document.body.removeChild(container.current);
    };
  }, []);

  if (visible) {
    return ReactDOM.createPortal(
      useModal ? (
        <NotificationModal message={message} onClose={dismiss} />
      ) : (
        <Notification
          message={message}
          messageIcon={messageIcon}
          onClose={dismiss}
          country={country}
        />
      ),
      container.current
    );
  }

  return null;
};

const mapStateToProps = (state) => {
  const { country } = state.appResources;
  return {
    country,
  };
};

export default connect(mapStateToProps)(Notifications);
